import React from 'react';
import DataTables from 'components/dataTables';
import { connect } from 'react-redux';
import { PostAction } from 'redux/actions';
import PageSpinner from 'components/PageSpinner';
import { Card } from 'reactstrap';
import PostContainer from './postContainer';
import TableCustomHeader from 'components/dataTables/tableCustomHeader';
import noImage from 'assets/img/users/no-image.jpg';
import Avatar from 'components/Avatar';
const Favourites = (props) => {

    React.useEffect(() => {
        let filters = { page: props.pagination.page, page_limit: props.pagination.page_limit, order_by: props.order.order_by, direction: props.order.direction }
       if(props.userId){
           filters['userId'] =   props.userId;
       }
        props.getFavourites(filters)
    }, [props.pagination, props.order, props.userId]);

    React.useEffect(() => {
        props.getTotalCount(props.totalRecord);
    }, [props.favourites])

    const renderImage = (value, tableMeta, updateValue) => {
        return (<Avatar src={(value) ? value : noImage}  />);
    }
    const columns = () => {
        let columnsList = [
            {
                name: "id",
                label: "S.No.",
            },
            {
                name: "image",
                label: "Image",
            },
            {
                name: "search_term",
                label: "Search Term",
            },
            {
                name: "type",
                label: "Type",
            },
            {
                name: "title",
                label: "Title",
            },
            {
                name: "description",
                label: "Description",
            }
        ];
        return columnsList.map((column, index) => {
            return {
                label: column.label,
                name: column.name,
                options: {
                    setCellProps: () => ({
                        style: (column.name === 'search_term' || column.name==='description' || column.name==='title') ? { maxWidth: "150px" }:{width:'auto'}
                    }),
                    customHeadRender: (columnMeta, updateDirection) => {
                        return <TableCustomHeader key={index} itemkey={index} order={props.order} columnMeta={columnMeta} updateDirection={updateDirection} />
                    },
                    customBodyRender: (column.name === 'image') ? renderImage : '',
                    display: (column.name === 'id') ? false : true
                }
            }
        })
    }
    return (
        <Card className="mb-3">
            {props.isLoading ? <PageSpinner />
                : <DataTables data={props.favourites} columns={columns()} options={props.options} />
            }</Card>
    );
}

const mapStateToProps = (state) => ({
    isLoading: (state.uiReducer && state.uiReducer.isLoading) ? state.uiReducer.isLoading : false,
    favourites: (state.post && state.post.favourites && state.post.favourites.favourites) ? state.post.favourites.favourites : [],
    totalRecord: (state.post && state.post.favourites && state.post.favourites.total_posts) ? state.post.favourites.total_posts : 0
});
const mapDispatchToProps = (dispatch) => ({
    getFavourites: (payload) => dispatch(PostAction.getFavourites(payload)),
});
export default PostContainer(connect(mapStateToProps, mapDispatchToProps)(Favourites), { defaultOrderBy: 'id' });